import { mapperModuleNavigationLink, mapperModuleUsp } from '../../../core/data-layer/modules/mappers'
import { mapperBlockCallToAction, mapperBlockFaqGroup } from '../../../core/data-layer/blocks/mappers'
import { mapperPaymentsPaymentMethod } from '../mappers'
import type { MapperOptions } from '#layers/core/types'

/**
 * Page pricing mapper
 * normalizes data to be used in pages
 *
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }
  // TODO: refactor this mapper

  return {
    description: data.description || '',
    link: mapperModuleNavigationLink(data.link, options.getUrl),
    linkText: data.linkText || '',
    cards: data.cardsCollection || [],
    usps: data.uspsCollection?.items.map((item) => mapperModuleUsp(item)).filter(Boolean) || [],
    faq: mapperBlockFaqGroup(data.faq),
    callToAction: mapperBlockCallToAction(data.callToAction, options.getUrl),
    paymentMethods: data.paymentMethods || []
  }
}
